export const identifyTenant = (user) => {
  if (!window.posthog) return;
  window.posthog.identify(String(user.id), {
    name: `${user.first_name} ${user.last_name}`.trim(),
    is_member: !!user.is_member,
    property_id: user.propertyId,
    actor_type: 'human',
  });
  window.posthog.group('property', String(user.propertyId), {});
};

export const resetTenant = () => {
  if (!window.posthog) return;
  window.posthog.reset();
};
